const OPUS_RTPMAP = /^a=rtpmap:(\d+) opus\//i;
const FMTP = /^a=fmtp:(\d+) (.*?)(\r?)$/;

type FmtpParams = Record<string, string | number>;

const applyParams = (fmtpParams: string, params: FmtpParams) => {
  const merged = new Map<string, string>();

  fmtpParams
    .split(';')
    .filter(Boolean)
    .forEach((token) => {
      const [key, ...value] = token.split('=');

      merged.set(key, value.join('='));
    });

  Object.entries(params).forEach(([key, value]) => merged.set(key, String(value)));

  return Array.from(merged, ([key, value]) => (value ? `${key}=${value}` : key)).join(';');
};

// Rewrites the whole opus format line instead of splicing tokens into it: Janus echoes our own
// munged offer back in the answer, so a substring replace re-appends parameters already present.
export const setOpusFmtpParams = (sdp: string, params: FmtpParams) => {
  const lines = sdp.split('\n');
  const opusPayloadTypes = new Set(lines.flatMap((line) => OPUS_RTPMAP.exec(line)?.[1] ?? []));

  if (!opusPayloadTypes.size) {
    return sdp;
  }

  return lines
    .map((line) => {
      const [, payloadType, fmtpParams, lineEnd] = FMTP.exec(line) ?? [];

      if (!payloadType || !opusPayloadTypes.has(payloadType)) {
        return line;
      }

      return `a=fmtp:${payloadType} ${applyParams(fmtpParams, params)}${lineEnd}`;
    })
    .join('\n');
};
